import 'moment/locale/ja';
import 'react-datetime/css/react-datetime.css';
import 'rup-styles-css/rup_styles.css';
import '../styles/styles.scss';
import '../styles/rup-components-override.scss';
import '../typings/window.d';
import GlobalAlertDialog from '../common/components/modal/globalAlertDialog';
import { IMainStore } from '../common/typings/stores';
import theme from '../styles/theme';
import { ThemeProvider } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			height: '100%'
		}
	})
);

const Page: React.FunctionComponent = props => {
	const classes = useStyles();
	return <div className={classes.root}>{props.children}</div>;
};

export function renderPage<TStore extends IMainStore>(page: React.ReactElement, stores: TStore): void {
	ReactDOM.render(
		<React.StrictMode>
			<Provider {...stores}>
				<ThemeProvider theme={theme}>
					<BrowserRouter basename={window.basePath}>{page}</BrowserRouter>
					<GlobalAlertDialog />
				</ThemeProvider>
			</Provider>
		</React.StrictMode>,
		document.getElementById('root')
	);
}

export default Page;
